import { render, staticRenderFns } from "./CourseVideoDetail.vue?vue&type=template&id=7bb1b4a8&scoped=true&"
import script from "./CourseVideoDetail.vue?vue&type=script&lang=js&"
export * from "./CourseVideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseVideoDetail.vue?vue&type=style&index=0&id=7bb1b4a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb1b4a8",
  null
  
)

export default component.exports